/**
 * /smartlinks/router — SmartLink router operator page.
 *
 * Mounts the feature #101 dash surface (single-URL multi-offer weighted
 * routing). Mirrors the breadcrumb + heading + DocHint shape used by the
 * campaigns/* routes (see `campaigns.os-targeting.tsx`) — but delegates the
 * full page rendering to `SmartlinkRouterPage` so the heading + headline
 * gradient live alongside the create/attach forms and tables in one
 * cohesive surface.
 *
 * This file intentionally stays thin: it wires TanStack Router to the
 * feature component via `createRoute`. Root picks it up during the
 * registry wire-up cycle.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SmartlinksRouterPage } from "@/features/smartlinks-router/SmartlinkRouterPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/smartlinks/router`.
// No search params yet; a future agent can surface a `?smartlinkId=` deep
// link once we add a list endpoint on the API side.
// ---------------------------------------------------------------------------

export const smartlinksRouterRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/smartlinks/router",
	component: SmartlinksRouterPage,
});

export { SmartlinksRouterPage };

export default smartlinksRouterRoute;
